import { actions } from './actions';
import * as sagas from './sagas';
export const docModel = { actions, sagas };
